enum DefaultStatusEnum {
  Days30 = '30 Days',
  Days60 = '60 Days',
  Days90 = '90 Days',
  Days180Plus = '180+ Days',
}

export default DefaultStatusEnum;
